import { API_URL as BASE_API_URL } from '@funnels/constants';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';

const fetch = (applicationId: string): Promise<any> => {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: {} });
  }
  return axios
    .get(`${BASE_API_URL}/required-actions/v1/application/${applicationId}/conditions/?status=Opened,UserMitigated`)
    .then((res) => res.data);
};

const requiredActionConditionsApi = { fetch };

export default requiredActionConditionsApi;
